
import React from 'react';
import { Button } from '@mui/material';
import Divider from '@mui/material/Divider'
import { Col, Row } from 'react-bootstrap';

import TallyForm from '../../../../Models/TallyForm.js'

class TallyFormComponent extends React.Component { 
    constructor(props,context) {
        super(props,context)
        this.api = new TallyForm()
        this.state = {
            forms: []
        }
    }

    componentDidMount() {
        this.initData(0)
    }

    async initData(retry) {
        if (retry > 5) {
            return
        }
        let forms = await this.api.GetTallyFormLinks()
        this.setState({
            forms: forms
        })
    }

    render() {
        return (
            this.state.forms.length > 0 && (
            <Col>
                <Row>
                    <Col style={{padding: 0}}>
                    <div style={{
                        fontWeight: "bold", 
                        fontSize: "1.5rem",
                        textAlign: "left",
                    }}>
                        Setup Checklists
                    </div>
                    <Divider style={{backgroundColor: "#D6D6D6"}}/>
                    </Col>
                </Row>
                <Row>
                    {this.state.forms.map((form, idx) => {
                        return (
                            <Col lg={3} xs={4}>
                                <a href={form.url} target="_blank" key={idx} style={{width: "100%"}}> 
                                    <Button variant="contained" className="watchlist-action" color="success" 
                                    style={{
                                        margin: "1em 0 ",
                                        width: "100%"
                                    }}>
                                        {form.description}
                                    </Button>
                                </a>
                            </Col>
                        )
                    })}
                </Row>
            </Col>
            )
        )
    }
}
export default TallyFormComponent;